// extracted by mini-css-extract-plugin
export default {"list":"NavSidebar_list__N6hJE","link":"NavSidebar_link__teh5h","disabled":"NavSidebar_disabled__LwCEn","active":"NavSidebar_active__wihl8"};